module.exports = __webpack_public_path__ + "packs/media/images/JungleSoci-54e4dca1427ba2acfa37e280c09e3c8a.jpg";